module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "size": 'md',
      "title": "Discussion Questions",
      "disableOutsideClick": true
    },
    on: {
      "close": _vm.saveGuidingQuestions
    }
  }, [_c('div', {
    staticClass: "flex flex-col flex-grow h-full overflow-y-auto px-6 pb-6"
  }, [_vm._l((_vm.new_guiding_questions), function(question, index) {
    return _c('div', {
      key: index,
      staticClass: "flex space-x-12 items-start justify-between mb-6"
    }, [_c('div', {
      staticClass: "flex items-start space-x-2"
    }, [_c('div', {
      staticClass: "font-poppins font-semibold text-gray-800"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('div', {
      staticClass: "font-poppins font-light text-gray-800"
    }, [_vm._v("\n          " + _vm._s(question.question) + "\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center"
    }, [(!_vm.editing_guiding_question) ? _c('div', {
      staticClass: "flex w-24 items-center justify-end space-x-3"
    }, [_c('div', {
      staticClass: "sample"
    }, [_c('button', {
      staticClass: "rounded-full w-8 h-8 bg-gray-200 text-gray-800",
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          return _vm.editGuidanceQuestion(index, question)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-edit"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "sample"
    }, [_c('button', {
      staticClass: "rounded-full w-8 h-8 bg-red-100 text-red-500",
      attrs: {
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteGuidanceQuestion(index)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash-alt"
    })])]), _vm._v(" "), _c('toggle-button', {
      staticClass: "toggle-button-class",
      attrs: {
        "labels": false,
        "title": 'Visible To Students',
        "color": "#72ccd7"
      },
      model: {
        value: (question.is_active),
        callback: function($$v) {
          _vm.$set(question, "is_active", $$v)
        },
        expression: "question.is_active"
      }
    })], 1) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full flex flex-col space-y-2"
  }, [_c('div', {
    staticClass: "w-full flex items-start space-x-2"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_guiding_question.question),
      expression: "new_guiding_question.question"
    }],
    staticClass: "rounded font-poppins bg-white font-light px-3 py-2 text-gray-800 border border-solid border-gray-200 placeholder-gray-600 w-full",
    attrs: {
      "rows": "4",
      "type": "text",
      "labelText": "",
      "placeholder": "Add a question..."
    },
    domProps: {
      "value": (_vm.new_guiding_question.question)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addEditQuestion.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.new_guiding_question, "question", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.editing_guiding_question) ? _c('button', {
    staticClass: "sample h-9 px-3 bg-primary text-white rounded",
    on: {
      "click": _vm.saveEditGuidanceQuestion
    }
  }, [_vm._v("\n          Save\n        ")]) : _c('button', {
    staticClass: "h-9 px-3 rounded bg-blueGray-800 text-white font-poppins",
    on: {
      "click": _vm.saveEditGuidanceQuestion
    }
  }, [_vm._v("\n          Add\n        ")])]), _vm._v(" "), (!_vm.editing_guiding_question) ? _c('div', {
    staticClass: "font-poppins font-light text-xs text-gray-700"
  }, [_vm._v("\n        Press + or enter to create question\n      ")]) : _vm._e()])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-11271d58!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/modals/guidingQuestionsModal.vue
// module id = 1784
// module chunks = 61